import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Search, XCircleIcon } from 'lucide-react';
import { Filter} from 'lucide-react';

import { convertDateTimeToFormat } from '../../../components/utils/utils';

import apiService from '../../../apiService/Subscription/api-service';

const TransactionTable = ({dateValue, filtersdata}) => {

    const [contentLoader, setContentLoader] = useState(false);

    const [entriesPerPage, setEntriesPerPage] = useState('50');
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [transactions, setTransactions] = useState([]);

    // Function to check if date range is within 3 months
    const isWithinThreeMonths = (fromDateStr, toDateStr) => {
        const fromDate = new Date(fromDateStr);
        const toDate = new Date(toDateStr);
        const maxToDate = new Date(fromDate);
        maxToDate.setMonth(maxToDate.getMonth() + 3);
        return toDate <= maxToDate;
    }


    async function fetchData() {
        if (!isWithinThreeMonths(dateValue?.startDate, dateValue?.endDate)) {
           return alert("Date range exceeds 3 months")
        }

        if (filtersdata.searchBy !== 'date') {
            if(filtersdata.searchTerm === ''){
                return alert("Search field cannot be blank")
            }
        }

        if(contentLoader) return;

        setContentLoader(true);

        const response = await apiService.fetchTransactions({
            searchBy: filtersdata?.searchBy || 'date',
            start_date: dateValue?.startDate,
            end_date: dateValue?.endDate,
            product_id: filtersdata?.productFilter || '',
            plan: filtersdata?.planFilter || '',
            platform: filtersdata?.platformFilter || '',
            search: filtersdata?.searchTerm || '',
            page: currentPage
        });
        const data = response.data?.data?.reportData || [];
        setTransactions(data.dataList)
        setTotalPages(data?.totalPages > 0 ? data?.totalPages : 1)
        setTotalRecords(data?.totalRecords > 0 ? data?.totalRecords : 0)
        setContentLoader(false);
    } 

    useEffect(() => {
    
        fetchData();
        
      },[currentPage, filtersdata])

    const getPlanStatus = (row) => {
        let status = 'active'
        if(row.is_cancelled){
            status = 'cancelled'
        }
        if(new Date(row.end_date) < new Date()){
            status = 'expired'
        }
        return status
    };

    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case 'active': return 'bg-green-100 text-green-800';
            case 'expired': return 'bg-red-100 text-red-800';
            case 'cancelled': return 'bg-gray-100 text-gray-800';
            case 'pending': return 'bg-yellow-100 text-yellow-800';
            case 'suspended': return 'bg-orange-100 text-orange-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    };
    return (
        <>
        {/* Table Section */}
        <div className="bg-white rounded-lg shadow-sm">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-50">
                        <tr>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SSOID</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plan Details</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Billing</th>
                        <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                        {/* <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th> */}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {contentLoader && <><tr className="hover:bg-gray-50">
                        <td className="px-4 py-4 whitespace-nowrap" colSpan={7}>Loading Content</td></tr></>}
                        {transactions.map((row) => {
                            const subscription = JSON.parse(row.subscription_meta_data)

                            let bilingDateObj = new Date(row.end_date)
                            bilingDateObj.setDate(bilingDateObj.getDate() + 1);
                            let day = String(bilingDateObj.getDate()).padStart(2, '0');
                            let month = String(bilingDateObj.getMonth() + 1).padStart(2, '0');
                            let year = bilingDateObj.getFullYear();
                            let activeBilling = `${day}/${month}/${year}`;
                        return <>
                        <tr key={`${row.id}`} className="hover:bg-gray-50">
                            <td className="px-4 py-4 whitespace-nowrap">
                                {/* <div className="text-sm font-medium text-gray-900">{row.id}</div> */}
                                <div className="text-xs text-gray-500">{row.user_id}</div>
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap">
                                <div className="flex flex-col">
                                    <div className="text-sm font-medium text-gray-900">{row.name}</div>
                                    <div className="text-xs text-gray-500">{row.email}</div>
                                    <div className="text-xs text-gray-500">{row.mobile}</div>
                                    <div className="text-xs text-gray-400">{row.country_name} • {row.state_name}</div>
                                </div>
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap">
                                <div className="flex flex-col">
                                    <div className="text-sm font-medium text-gray-900">{subscription.subscription_name}</div>
                                    <div className="text-xs text-gray-500">{row.subscription_type} • {row.duration_type}</div>
                                    {row.free_trial_type !== 'none'  && (
                                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 mt-1 w-fit">
                                        Free Trial
                                    </span>
                                    )}
                                    {row.promo_code_discount_type !== 'none' && (
                                    <span className="text-xs text-green-600">
                                        {row.promo_code_discount_amount}
                                    </span>
                                    )}
                                </div>
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap">
                                <div className="flex flex-col">
                                    <div className="text-sm font-medium text-gray-900">
                                    {row.currency} {row.payable_amount}
                                    </div>
                                    {row.currency === 'USD' && (
                                    <div className="text-xs text-gray-500">
                                        INR {row.inr_amount}
                                    </div>
                                    )}
                                    {/* <div className="text-xs text-gray-500">{subscription.paymentMethod}</div> */}
                                    <div className="flex items-center mt-1">
                                        <span className="text-xs text-gray-500">Auto-renewal:</span>
                                        <span className={`ml-1 text-xs ${row.subscription_type === "recurring" && row.is_cancelled === 0 ? 'text-green-600' : 'text-red-600'}`}>
                                            {subscription.subscription_type === "recurring" && subscription.is_cancelled === 0 ? 'YES' : 'NO'}
                                        </span>
                                    </div>
                                    <div className="text-xs text-gray-400">{row.subscription_type === "recurring" && row.is_cancelled === 0 ? `Next: ${activeBilling}` : ``}</div>
                                    
                                </div>
                            </td>
                            <td className="px-2 py-4">
                                <div className="flex flex-col">
                                    <div className="text-xs text-gray-500" >TXN: {row.transaction_id}</div>
                                    <div className="text-xs text-gray-500"> {row.razorpay_order_id ? `OrderID: ${row.razorpay_order_id}` : ''}</div>
                                    <div className="text-xs text-gray-500"> {row.razorpay_sub_id ? `PlanID: ${row.razorpay_sub_id}` : ''}</div>
                                    <div className="text-xs text-gray-500"> {row.razorpay_payment_id ? `PayID: ${row.razorpay_payment_id}` : ''}</div>
                                </div>
                            </td>
                            <td className="px-4 py-4">
                                <div className="flex flex-col">
                                    <div className="text-xs text-gray-500">Start: {convertDateTimeToFormat(row.start_date, 3)}</div>
                                    <div className="text-xs text-gray-500">End: {convertDateTimeToFormat(row.end_date,3)}</div>
                                    {/* <div className="text-xs text-green-500">Created: {convertDateTimeToFormat(subscription.created_at, 2)}</div> */}
                                </div>
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap">
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(getPlanStatus(row))}`}>
                                    {getPlanStatus(row).toUpperCase()}
                                </span>
                            </td>
                        </tr>
                        </>
                        })}
                    </tbody>
                </table>
            </div>
            <div className="px-4 py-3 border-t border-gray-200">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div className="text-sm text-gray-700">
                        Showing 1 to {Math.min(parseInt(entriesPerPage), transactions.length)} of {totalRecords} entries
                    </div>
                    <div className="flex items-center space-x-2">
                        <button className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={currentPage === 1 || contentLoader}
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        >Previous</button>
                        <span className="text-sm text-gray-700">Page {currentPage} of {totalPages}</span>
                        <button className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" disabled={currentPage === totalPages || contentLoader}
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        >Next</button>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
    
}

export default TransactionTable;